import Cookies from "js-cookie";
import { createContext, useContext, useEffect, useReducer } from "react";
import { useAuthContext } from "./AuthContext";

export const AppContext = createContext(null);
export const useAppContext = () => useContext(AppContext);

function reducer(state, action) {
  switch (action.type) {
    case "DARK_MODE":
      return { ...state, darkMode: action.payload };
    default:
      throw new Error();
  }
}

export function AppProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, { darkMode: false });

  const _handleOnLoad = async () => {
    const darkMode = await Cookies.get("darkMode");
    dispatch({ type: "DARK_MODE", payload: darkMode == "true" ? true : false });
  };
  const auth = useAuthContext();

  useEffect(() => {
    _handleOnLoad();
  }, [auth.state.user]);

  const toggleDarkMode = async () => {
    await Cookies.set("darkMode", !state.darkMode);
    await Cookies.set("darkMode", !state.darkMode, { domain: ".getactyv.com" });
    dispatch({ type: "DARK_MODE", payload: !state.darkMode });
  };
  return (
    <AppContext.Provider value={{ state, toggleDarkMode }}>
      {children}
    </AppContext.Provider>
  );
}
